import "./Home.css";
import Railway from "./images/railway.jpg";
import Environment from "./images/enviromental.jpg";
import Construction from "./images/construction.jpg";
import Engineering from "./images/Nuts-and-bolts.jpg"
import {useEffect} from "react";
import { Link } from "react-router-dom";

const Home = ({redirectToTop}) => {   

    useEffect(() => {
        const boxes = Array.from(document.querySelectorAll(".services-section"));
        
        window.addEventListener("scroll", checkBoxes);

        checkBoxes();

        function checkBoxes(){
            const trigger =  window.innerHeight / 5 * 4;
            boxes.forEach(box => {
                const boxTop = box.getBoundingClientRect().top;
                if(boxTop < trigger)
                {
                    box.classList.add("show");
                } 
                
        })        
        }
    }, []);

    return ( 
        <>
            <h1 className="heading">Our Services</h1>
            <div className="services">
                
                <div className={`services-section `}>
                    <img src={Railway} alt="" />
                    <div className="copy">
                        <h3>Railway</h3>
                        <p>We are deeply invloved in the Railway industry, our contribution thus have have been Roiling Stock Components, Supply and Installation of certain elements, Maintenance and Support where needed. </p>
                    </div>
                    <div className="line line1"></div>
                </div> 
                <div className={`services-section `}>
                    <div className="line line2"></div>
                    <div className="copy">
                        <h3>Environmental Serivces</h3>
                        <p>Our invlovement in the Enviromental Services spans, Roiling Stock Components, Industrial Cleaning Landscaping, Site Clearing, Dredging Services, Irrigation Systems, Maintenance and field services. </p>
                    </div>
                    <img src={Environment} alt="" />
                    
                </div>
                <div className={`services-section `}>
                    <img src={Construction} alt="" />
                    <div className="line line3"></div>
                    <div className="copy">
                        <h3>Construction And Telecommunications</h3>
                        <p>Our invlovement in the Enviromental Services spans, Civil Works, Maintenance, Paving, Painting, Fibre Optic. </p>
                    </div>
                </div>
                <div className={`services-section  `}>
                <div className="copy">
                        <h3>Engineering and Manufacturing</h3>
                        <p>We Render our engineering and manufacturing services to public entites and private entites. We provide Valves, Pumps, pipes, Heat Exchangers.</p>
                    </div>
                    <img src={Engineering} alt="" />
                    <div className="line line1"></div>
                </div>
                <button className="btn btn2"><Link to="/service" onClick={redirectToTop}>See All Our Services</Link></button>
            </div>
        </>
     );
}
 
export default Home;